"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _elementUi = require("element-ui");
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/utils/auth");
var _request = require("@/utils/request");
var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // progress bar
// progress bar style
// get token from cookie
// get token from cookie
_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration

/** 需强制改密时，禁止在系统内切换路由（允许从登录页进入、允许首屏与刷新） */
function shouldBlockNavigationForForcePasswordChange(from, to) {
  if (!_store.default.getters.needForceChangePassword) return false;
  if (!from.matched || from.matched.length === 0) return false;
  var fp = from.path || '';
  if (fp.indexOf('/login') === 0 || fp === '/regist') return false;
  if (to.fullPath === from.fullPath) return false;
  return true;
}
var whiteList = ['/login', '/regist', '/', '/join', '/product', '/about', '/news', '/newsDetail']; // no redirect whitelist

_router.default.beforeEach(/*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, hasGetUserInfo, accessRoutes, _yield$store$dispatch, level_key, _accessRoutes, accessss, _t;
    return regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          _nprogress.default.start();

          // set page title
          //document.title = getPageTitle(to.meta.title)

          // determine whether the user has logged in
          hasToken = (0, _auth.getToken)();
          if (!hasToken) {
            _context.next = 17;
            break;
          }
          if (!(to.path.indexOf('/login') > -1)) {
            _context.next = 1;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          _nprogress.default.done();
          _context.next = 16;
          break;
        case 1:
          hasGetUserInfo = _store.default.getters.name;
          if (!hasGetUserInfo) {
            _context.next = 3;
            break;
          }
          if (!shouldBlockNavigationForForcePasswordChange(from, to)) {
            _context.next = 2;
            break;
          }
          next(false);
          _nprogress.default.done();
          return _context.abrupt("return");
        case 2:
          next();
          _context.next = 16;
          break;
        case 3:
          _context.prev = 3;
          _context.next = 4;
          return _store.default.dispatch('user/getPlatformConfig');
        case 4:
          if (!((0, _auth.getToken)('user_id') == 97)) {
            _context.next = 7;
            break;
          }
          _context.next = 5;
          return _store.default.dispatch('permission/generateRoutes', ['qrcode']);
        case 5:
          accessRoutes = _context.sent;
          // dynamically add accessible routes
          _router.default.addRoutes(accessRoutes);
          _context.next = 6;
          return _store.default.dispatch('user/checkFirstLoginPasswordStatus');
        case 6:
          _context.next = 13;
          break;
        case 7:
          _context.next = 8;
          return _store.default.dispatch('user/getDeviceType');
        case 8:
          _context.next = 9;
          return _store.default.dispatch('user/getInfo');
        case 9:
          _yield$store$dispatch = _context.sent;
          level_key = _yield$store$dispatch.level_key;
          console.log(level_key);

          // generate accessible routes map based on roles
          _context.next = 10;
          return _store.default.dispatch('permission/generateRoutes', [level_key]);
        case 10:
          _accessRoutes = _context.sent;
          _router.default.addRoutes(_accessRoutes);
          if (!((0, _auth.getPermission)('server_permission_menus') !== 'undefined')) {
            _context.next = 12;
            break;
          }
          if (!((0, _auth.getPermission)('server_permission_roles') !== 'super')) {
            _context.next = 12;
            break;
          }
          _context.next = 11;
          return _store.default.dispatch('permission/generateServiceRoutes', (0, _auth.getPermission)('server_permission_menus'));
        case 11:
          accessss = _context.sent;
          _router.default.addRoutes(accessss);
        case 12:
          _context.next = 13;
          return _store.default.dispatch('user/checkFirstLoginPasswordStatus');
        case 13:
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          next();
          _context.next = 16;
          break;
        case 14:
          _context.prev = 14;
          _t = _context["catch"](3);
          //remove token and go to login page to re-login
          console.log(_t);
          _context.next = 15;
          return _store.default.dispatch('user/resetToken');
        case 15:
          _elementUi.Message.error(_t || 'Has Error');
          next("/login?redirect=".concat(to.path));
          _nprogress.default.done();
        case 16:
          _context.next = 18;
          break;
        case 17:
          /* has no token*/
          if (whiteList.indexOf(to.path) !== -1 || to.path.indexOf('/login') !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            console.log('dddddd');
            if ((0, _auth.getToken)('agent_id') !== undefined && (0, _auth.getToken)('agent_id') !== null) {
              next('/login/' + (0, _auth.getToken)('agent_id'));
            } else {
              // 调用接口根据IP获取agent_id
              (0, _request.$get)('/commonapi/configer/getAgentIdByIp').then(function (data) {
                console.log(data);
                if (data.agent_id) {
                  next('/login/' + data.agent_id);
                } else {
                  next("/login?redirect=".concat(to.path));
                }
              }).catch(function () {
                next("/login?redirect=".concat(to.path));
              });
            }
            _nprogress.default.done();
          }
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 14]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});